import {PixagriField} from 'library/src/fields/models/PixagriField';
import {ServiceId} from 'shared/models/RouterParam';
import {FieldSubscribeStatus} from '../models/FieldSubscribeStatus';
import {isFieldComplete, isFieldSubscribe} from '../services/FieldsService';

function getFieldSubscribeStatusForFilter(
  field: PixagriField,
  selectedService: ServiceId | null,
  selectedCampaign: number | null,
): FieldSubscribeStatus {
  if (!selectedService || !selectedCampaign) {
    // par défaut : si pas de contexte, on considère NON_COMPLETÉ
    return FieldSubscribeStatus.NOT_COMPLETED;
  }

  const subscribed = isFieldSubscribe(selectedService, selectedCampaign, field);
  const completed = isFieldComplete(selectedService, selectedCampaign, field);

  if (subscribed && completed) {
    return FieldSubscribeStatus.SUBSCRIBED;
  }

  if (!subscribed && completed) {
    return FieldSubscribeStatus.NOT_SUBSCRIBED;
  }

  return FieldSubscribeStatus.NOT_COMPLETED;
}

export default getFieldSubscribeStatusForFilter;
